import protoRoot from "../proto-root";
import createMessage from "./createMessage";

const name = "appStateMessage";

function create({ state }) {
  const AppStateMessage = protoRoot.lookupType("comm.AppStateMessage");
  const AppState = AppStateMessage.lookupEnum("AppState");

  const appStateMessage = AppStateMessage.create({
    state: AppState.values[state]
  });

  return createMessage({ [name]: appStateMessage });
}

export default {
  create,
  name
};

// message AppStateMessage {
//     enum AppState {
//         FOREGROUND = 0;
//         BACKGROUND = 1;
//     }
//     AppState state = 1;
// }
